export const SIDEBAR_WIDTH_MIN = 200;
export const SIDEBAR_WIDTH_MAX = 520;
export const SIDEBAR_WIDTH_DEFAULT = 256;

const STORAGE_KEY = "sidebar:width";

export function clampSidebarWidth(px: number): number {
  if (!Number.isFinite(px)) return SIDEBAR_WIDTH_DEFAULT;
  return Math.min(
    SIDEBAR_WIDTH_MAX,
    Math.max(SIDEBAR_WIDTH_MIN, Math.round(px))
  );
}

export function readSidebarWidth(): number {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === null) return SIDEBAR_WIDTH_DEFAULT;
    return clampSidebarWidth(Number(stored));
  } catch {
    return SIDEBAR_WIDTH_DEFAULT;
  }
}

export function writeSidebarWidth(px: number): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(clampSidebarWidth(px)));
  } catch {
    // stocarea locală poate lipsi (fereastră privată, previzualizare); lățimea rămâne doar în memorie
  }
}
